export const getInAppSessionStorage = (name: string): string | null => {
  return typeof window !== 'undefined' ? sessionStorage.getItem(name) : null;
};

export const setInAppSessionStorage = (name: string, value: string) => {
  if (typeof window !== 'undefined') {
    sessionStorage.setItem(name, value);
  }
};

export const removeInAppSessionStorage = (name: string) => {
  if (typeof window !== 'undefined') {
    sessionStorage.removeItem(name);
  }
};
